import { ImportFieldTypes, EStudentImportAttributeFieldNames as Field } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const importStudentFields = deepFreeze({
  // GENERAL FIELDS
  [Field.ADDRESS_LINE_1]: {
    summaryField: null,
    name: 'addressLine1',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.ADDRESS_LINE_2]: {
    summaryField: null,
    name: 'addressLine2',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.ADDRESS_LINE_3]: {
    summaryField: null,
    name: 'addressLine3',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.AGENT_COMPANY]: {
    summaryField: null,
    name: 'agentCompany',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.AGENT_COMPANY_EMAIL]: {
    summaryField: null,
    name: 'agentCompanyEmail',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.AGENT_EMAIL]: {
    summaryField: null,
    name: 'agentEmail',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.AGENT_NAME]: {
    summaryField: 'agentName',
    summaryFieldType: 'string',
    name: 'agentName',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Agent Name'
  },
  [Field.AGENT_OFFICE]: {
    summaryField: null,
    name: 'agentOffice',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.APPLICATION_DATE]: {
    summaryField: null,
    name: 'applicationDate',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.APPLICATION_ID]: {
    summaryField: null,
    name: 'applicationId',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.BRANCH_OFFICE]: {
    summaryField: null,
    name: 'branchOffice',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.CITY]: {
    summaryField: 'city',
    summaryFieldType: 'string',
    name: 'city',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'City'
  },
  [Field.COMPANY_NAME]: {
    summaryField: null,
    name: 'companyName',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.CONFIRMED]: {
    summaryField: null,
    name: 'confirmed',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.COUNSELLOR_EMAIL]: {
    summaryField: null,
    name: 'counsellorEmail',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.COUNSELLOR_NAME]: {
    summaryField: null,
    name: 'counsellorName',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.COUNTRY]: {
    summaryField: 'country',
    summaryFieldType: 'string',
    name: 'country',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Country'
  },
  [Field.COUNTRY_OF_BIRTH]: {
    summaryField: null,
    name: 'countryOfBirth',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.CRIMINAL_CONVICTIONS]: {
    summaryField: 'criminalConvictions',
    summaryFieldType: 'boolean',
    name: 'criminalConvictions',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Criminal Convictions'
  },
  [Field.DOB]: {
    summaryField: 'dob',
    summaryFieldType: 'string',
    name: 'dob',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Date of Birth'
  },
  [Field.EMAIL]: {
    summaryField: 'email',
    summaryFieldType: 'string',
    name: 'email',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Email'
  },
  [Field.ENGLISH_LEVEL_ATTAINED]: {
    summaryField: null,
    name: 'englishLevelAttained',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.ENGLISH_TEST_PROVIDER]: {
    summaryField: null,
    name: 'englishTestProvider',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.FAMILY_NAME]: {
    summaryField: 'surname',
    summaryFieldType: 'string',
    name: 'familyName',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Family Name'
  },
  [Field.GENDER]: {
    summaryField: null,
    name: 'gender',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.GIVEN_NAME]: {
    summaryField: 'givenName',
    summaryFieldType: 'string',
    name: 'givenName',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Given Name'
  },
  [Field.NATIONALITY]: {
    summaryField: 'nationality',
    summaryFieldType: 'string',
    name: 'nationality',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Nationality'
  },
  [Field.OTHER_NAME]: {
    summaryField: null,
    name: 'otherName',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.PASSPORT_EXPIRY]: {
    summaryField: null,
    name: 'passportExpiry',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.PASSPORT_NUMBER]: {
    summaryField: null,
    name: 'passportNumber',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.PHONE]: {
    summaryField: 'phone',
    summaryFieldType: 'string',
    name: 'phone',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Phone'
  },
  [Field.PLACE_OF_BIRTH]: {
    summaryField: null,
    name: 'placeOfBirth',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.POSTCODE]: {
    summaryField: 'postcode',
    summaryFieldType: 'string',
    name: 'postcode',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Postcode'
  },
  [Field.PREVIOUS_COURSE_COMPLETION]: {
    summaryField: null,
    name: 'previousCourseCompletion',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.PREV_UK_STUDY]: {
    summaryField: null,
    name: 'prevUKStudy',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.SELT_LISTENING]: {
    summaryField: null,
    name: 'seltListening',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.SELT_READING]: {
    summaryField: null,
    name: 'seltReading',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.SELT_SPEAKING]: {
    summaryField: null,
    name: 'seltSpeaking',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.SELT_WRITING]: {
    summaryField: null,
    name: 'seltWriting',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: ''
  },
  [Field.STUDENT_NO]: {
    summaryField: 'studentNo',
    summaryFieldType: 'string',
    name: 'studentNo',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Student Number'
  },
  [Field.UCAS_ID]: {
    summaryField: 'ucasId',
    summaryFieldType: 'string',
    name: 'ucasId',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'UCAS ID'
  },
  [Field.WITH_AGENT]: {
    summaryField: 'withAgent',
    summaryFieldType: 'boolean',
    name: 'withAgent',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'With Agent'
  },
  [Field.ADMISSIONS_OFFICE]: {
    summaryField: 'admissionsOffice',
    summaryFieldType: 'string',
    name: 'admissionsOffice',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Uni Office'
  },
  [Field.SERVICES_ASSIGNED]: {
    summaryField: 'partners',
    summaryFieldType: 'string',
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Services'
  },
  [Field.TAGS_ASSIGNED]: {
    summaryField: 'tags',
    summaryFieldType: 'string',
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Tags'
  },
  [Field.STAGE]: {
    summaryField: 'cas_status',
    summaryFieldType: 'string',
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Stage'
  },
  [Field.AGE]: {
    summaryField: 'age',
    summaryFieldType: 'number',
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Age'
  },
  [Field.VISA_APPLICATION_COUNTRY]: {
    summaryField: 'countryOfVisaApplication',
    summaryFieldType: 'string',
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Country of Visa Application'
  },
  [Field.RISK_REGION]: {
    summaryField: 'regionConfigId',
    summaryFieldType: 'string',
    name: null,
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Risk Region'
  },
  // OFFER FIELDS
  [Field.COURSE_FEE_PAID_TO_DATE]: {
    summaryField: 'courseFeePaidToDate',
    summaryFieldType: 'number',
    name: 'courseFeePaidToDate',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.ACCOM_FEE_PAID_TO_DATE]: {
    summaryField: null,
    name: 'accomFeePaidToDate',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.IS_SELT_REQD]: {
    summaryField: null,
    name: 'isSELTReqd',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.REASON_SELT_NOT_REQD]: {
    summaryField: null,
    name: 'reasonSELTNotReqd',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.PREVIOUS_COURSE_LEVEL]: {
    summaryField: null,
    name: 'previousCourseLevel',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.COURSE_PROGRESSION]: {
    summaryField: null,
    name: 'courseProgression',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.PROGRESSION_TEXT]: {
    summaryField: null,
    name: 'progressionText',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  [Field.DOCS_USED_TO_OBTAIN_OFFER]: {
    summaryField: null,
    name: 'docsUsedToObtainOffer',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: ''
  },
  // COURSE FIELDS
  [Field.IS_ACCOM_PROVIDED]: {
    summaryField: null,
    name: 'isAccomProvided',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.IS_ACCOM_INCLUDED_COURSE_FEE]: {
    summaryField: null,
    name: 'isAccomIncludedCourseFee',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.IS_WORK_PLACEMENT]: {
    summaryField: null,
    name: 'isWorkPlacement',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_PERC]: {
    summaryField: null,
    name: 'workPlacementPerc',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_TEXT]: {
    summaryField: null,
    name: 'workPlacementText',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_1]: {
    summaryField: null,
    name: 'workPlacementAddressLine1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_2]: {
    summaryField: null,
    name: 'workPlacementAddressLine2',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_ADDRESS_LINE_3]: {
    summaryField: null,
    name: 'workPlacementAddressLine3',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_ID]: {
    summaryField: 'id',
    summaryFieldType: 'string',
    name: 'id',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: 'Course ID'
  },
  [Field.OFFERS_PRESESSIONAL_TITLE]: {
    summaryField: 'title',
    summaryFieldType: 'string',
    name: 'title',
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: 'PSE Course Title'
  },
  [Field.OFFERS_COURSES_TITLE]: {
    summaryField: 'title',
    summaryFieldType: 'string',
    name: 'title',
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: 'Course Title'
  },
  [Field.OFFERS_COURSES_CONDITIONAL]: {
    summaryField: null,
    name: 'conditional',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_DECLINED]: {
    summaryField: null,
    name: 'isDeclined',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CAH3]: {
    summaryField: null,
    name: 'cah3',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_LEVEL]: {
    summaryField: 'level',
    summaryFieldType: 'string',
    name: 'level',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: 'Course Level'
  },
  [Field.OFFERS_COURSES_SECONDARY_LEVEL]: {
    summaryField: null,
    name: 'secondaryLevel',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_PRESESSIONAL_START_DATE]: {
    summaryField: 'startDate',
    summaryFieldType: 'string',
    name: 'startDate',
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: 'PSE Course Start Date'
  },
  [Field.OFFERS_COURSES_START_DATE]: {
    summaryField: 'startDate',
    summaryFieldType: 'string',
    name: 'startDate',
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: 'Course Start Date'
  },
  [Field.OFFERS_PRESESSIONAL_END_DATE]: {
    summaryField: null,
    name: 'endDate',
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: ''
  },
  [Field.OFFERS_COURSES_END_DATE]: {
    summaryField: null,
    name: 'endDate',
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: ''
  },
  [Field.OFFERS_PRESESSIONAL_FEE]: {
    summaryField: null,
    name: 'courseFeeFirstYear',
    type: ImportFieldTypes.COURSE,
    isPresessional: true,
    label: ''
  },
  [Field.OFFERS_COURSES_FEE]: {
    summaryField: null,
    name: 'courseFeeFirstYear',
    type: ImportFieldTypes.COURSE,
    isPresessional: false,
    label: ''
  },
  [Field.OFFERS_COURSES_SCHOLARSHIP_AMOUNT1]: {
    summaryField: null,
    name: 'courseScholarshipAmount1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_SCHOLARSHIP_TITLE1]: {
    summaryField: null,
    name: 'courseScholarshipTitle1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_INNER_LONDON]: {
    summaryField: 'innerLondon',
    name: 'innerLondon',
    type: ImportFieldTypes.COURSE,
    summaryFieldType: 'boolean',
    isPresessional: null,
    label: 'Inner London'
  },
  [Field.OFFERS_COURSES_LAST_ACCEPTANCE_DATE]: {
    summaryField: null,
    name: 'lastAcceptanceDate',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_IS_FULL_TIME]: {
    summaryField: null,
    name: 'isFullTime',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_HOURS_PER_WEEK]: {
    summaryField: null,
    name: 'hoursPerWeek',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_ATAS]: {
    summaryField: null,
    name: 'isATASRequired',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT1]: {
    summaryField: null,
    name: 'conditionText1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT2]: {
    summaryField: null,
    name: 'conditionText2',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT3]: {
    summaryField: null,
    name: 'conditionText3',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT4]: {
    summaryField: null,
    name: 'conditionText4',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT5]: {
    summaryField: null,
    name: 'conditionText5',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT6]: {
    summaryField: null,
    name: 'conditionText6',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT7]: {
    summaryField: null,
    name: 'conditionText7',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT8]: {
    summaryField: null,
    name: 'conditionText8',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_CONDITIONS_TEXT9]: {
    summaryField: null,
    name: 'conditionText9',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_FACULTY]: {
    summaryField: 'faculty',
    summaryFieldType: 'string',
    name: 'faculty',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: 'Faculty'
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_1]: {
    summaryField: null,
    name: 'studyAddressLine1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_2]: {
    summaryField: null,
    name: 'studyAddressLine2',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.MAIN_STUDY_ADDRESS_LINE_3]: {
    summaryField: null,
    name: 'studyAddressLine3',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.MAIN_STUDY_ADDRESS_CITY]: {
    summaryField: null,
    name: 'studyCity',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.MAIN_STUDY_ADDRESS_COUNTRY]: {
    summaryField: null,
    name: 'studyCountry',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.MAIN_STUDY_ADDRESS_POSTCODE]: {
    summaryField: null,
    name: 'studyPostcode',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_ADDRESS_CITY]: {
    summaryField: null,
    name: 'workPlacementCity',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_ADDRESS_COUNTRY]: {
    summaryField: null,
    name: 'workPlacementCountry',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.WORK_PLACEMENT_ADDRESS_POSTCODE]: {
    summaryField: null,
    name: 'workPlacementPostcode',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_OFFER_EVIDENCE]: {
    summaryField: null,
    name: 'offerEvidence',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_ACCEPTED]: {
    summaryField: null,
    name: 'coursesAccepted',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_HECOS1]: {
    summaryField: null,
    name: 'offers_courses_qual_hecos1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_HECOS2]: {
    summaryField: null,
    name: 'offers_courses_qual_hecos2',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_HECOS3]: {
    summaryField: null,
    name: 'offers_courses_qual_hecos3',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_HECOS4]: {
    summaryField: null,
    name: 'offers_courses_qual_hecos4',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_HECOS5]: {
    summaryField: null,
    name: 'offers_courses_qual_hecos5',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION1]: {
    summaryField: null,
    name: 'offers_courses_qual_proportion1',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION2]: {
    summaryField: null,
    name: 'offers_courses_qual_proportion2',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION3]: {
    summaryField: null,
    name: 'offers_courses_qual_proportion3',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION4]: {
    summaryField: null,
    name: 'offers_courses_qual_proportion4',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_PROPORTION5]: {
    summaryField: null,
    name: 'offers_courses_qual_proportion5',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFERS_COURSES_QUAL_CAT]: {
    summaryField: null,
    name: 'offers_courses_qual_cat',
    type: ImportFieldTypes.COURSE,
    isPresessional: null,
    label: ''
  },
  [Field.OFFER_ID]: {
    summaryField: 'offerId',
    summaryFieldType: 'string',
    name: 'offerId',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Offer ID'
  },
  [Field.INTAKE_ID]: {
    summaryField: 'intakeId',
    summaryFieldType: 'string',
    name: 'intakeId',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Intake ID'
  },
  [Field.UNI_PARTNER_ID]: {
    summaryField: 'uniPartnerId',
    summaryFieldType: 'string',
    name: 'uniPartnerId',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Secondary Student Number'
  },
  [Field.UNI]: {
    summaryField: 'uni',
    summaryFieldType: 'string',
    name: 'uni',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'University'
  },
  [Field.PATHWAY]: {
    summaryField: 'pathway',
    summaryFieldType: 'string',
    name: 'pathway',
    type: ImportFieldTypes.GENERAL,
    isPresessional: null,
    label: 'Pathway Provider'
  },
  [Field.EXTERNAL_CAS_STATUS]: {
    summaryField: 'externalCasStatus',
    summaryFieldType: 'string',
    name: 'externalCasStatus',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'CAS Bypass'
  },
  [Field.OFFERS_DURATION_MONTHS]: {
    summaryField: 'offersDurationMonths',
    summaryFieldType: 'number',
    name: 'offersDurationMonths',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Offers Duration Months'
  },
  [Field.TUITION_DEPOSIT]: {
    summaryField: 'tuitionDeposit',
    summaryFieldType: 'number',
    name: 'depositAmount',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Tuition Deposit'
  },
  [Field.DEPOSIT_AMOUNT]: {
    summaryField: 'depositAmount',
    summaryFieldType: 'number',
    name: 'depositAmount',
    type: ImportFieldTypes.OFFER,
    isPresessional: null,
    label: 'Tuition Deposit'
  }
} as const);
